<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between px-6 py-4 bg-gray-200 md:flex-shrink-0 md:justify-center md:w-56">
            <Link class="mt-1" href="/">
              <img :src="app.logo_b" :alt="`${app.name} logo`" width="120" height="28" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-blue-800 shadow-lg">
                  <main-menu :user="auth.user" />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="hidden md:flex md:text-md flex items-center justify-between p-4 w-full text-sm bg-gray-200 border-b md:px-12 md:py-0">
            <main-menu :user="auth.user" class="flex justify-end" />
            <dropdown class="m-2 px-2" placement="bottom-end">
              <template #default>
                <div class="group flex items-center cursor-pointer select-none py-2">
                  <div class="mr-1 text-gray-700 group-hover:text-blue-600 focus:text-blue-600 whitespace-nowrap">
                    <span>{{ auth.user.first_name }}</span>
                    <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                  </div>
                  <icon class="w-5 h-5 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="cheveron-down" />
                </div>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white  shadow-xl">
                  <Link class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/users/${auth.user.id}/edit`">My Profile</Link>
                  <Link v-for="(m, i) in auth.user.menu" :key="i" class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="m.route"> {{ m.label }} </Link>
                  <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-blue-500" href="/logout" method="delete" as="button">Logout</Link>
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <div id="scroll-region" class="px-4 py-8 md:flex-1 md:py-12 md:overflow-y-auto bg-white" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
        <div class="p-4 bg-blue-800">
          <img :src="app.logo_w" :alt="`${app.name} logo`" width="120" height="28" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    MainMenu,
  },
  props: {
    app: Object,
    auth: Object,
  },
}
</script>
